import { Flex } from "antd";
import { JobDto } from "../../../constant";
import styles from "./index.module.less";
import TimeIcon from "../../imgs/time.svg?react";
import LocationIcon from "../../imgs/location.svg?react";
import CategoryIcon from "../../imgs/category.svg?react";
import ArrowLeftIcon from "@/assets/imgs/return.png";
import SVGIcon from "@/components/SVGIcon";

const JobDetail = ({
  data,
  onSubmit,
  onReturn,
}: {
  data: JobDto;
  onSubmit: () => void;
  onReturn: () => void;
}) => {
  const { title, desc, date, locations, category, requirement } = data;
  return (
    <div className={styles.jobDetail}>
      <Flex
        gap={".12rem"}
        align="center"
        onClick={() => {
          onReturn?.();
        }}
        className={styles.backBtn}
      >
        <img
          src={ArrowLeftIcon}
          style={{
            width: ".2rem",
          }}
        />
        返回
      </Flex>
      <div className={styles.content}>
        <div className={styles.title}>{title}</div>
        <Flex gap={".2rem"} className={styles.info}>
          <Flex gap={4} align="center">
            <SVGIcon icon={<CategoryIcon />} />
            {category}
          </Flex>
          <Flex gap={4} align="center">
            <SVGIcon icon={<LocationIcon />} />
            {locations.join("/")}
          </Flex>
          <Flex gap={4} align="center">
            <SVGIcon icon={<TimeIcon />} />
            更新于{date}
          </Flex>
        </Flex>
        <div className={styles.requirements}>
          <div className={styles.requirementsTitle}>职位描述</div>
          <div className={styles.requirementsList}>
            {/* {requirements?.map((item, index) => (
            <div key={index}>
              {index + 1}、{item}
            </div>
          ))} */}
            <div className={styles.desc}>{requirement}</div>
          </div>
        </div>
        <div className={styles.requirements}>
          <div className={styles.descTitle}>职位要求</div>
          <div className={styles.desc}>{desc}</div>
        </div>
      </div>
      <div className={styles.footerSubmitBtn} onClick={onSubmit}>
        <div className={styles.submitBtn}>立即投递</div>
      </div>
    </div>
  );
};
export default JobDetail;
